import React, { FunctionComponent } from 'react';
import { ChatSupportProvider } from '@blocs.chat-support';
import { PermissionsProvider } from '@minecraft.permissions';
import LanguageSetter from '../IntlFeature/LanguageSetter';

interface Props {
  shouldHideChatSupport?: boolean;
  forceShowChatSupport?: boolean;
  children: JSX.Element;
}

/**
 * Provides standard context setters for all routes that are not authenticated
 * (`PermissionsProvider`, `ChatSupportProvider`, `LanguageSetter`)
 * Wrap all unauthenticated pages in this component to ensure that the context is set up correctly.
 * For pages that require authentication, use `AuthenticatedWrapper` instead.
 */
const UnauthenticatedWrapper: FunctionComponent<Props> = ({
  shouldHideChatSupport,
  forceShowChatSupport,
  children,
}) => {
  return (
    <PermissionsProvider>
      <ChatSupportProvider shouldHide={shouldHideChatSupport} bypassPermissionsCheck={forceShowChatSupport} />
      <LanguageSetter authenticated={false} loaded>
        {children}
      </LanguageSetter>
    </PermissionsProvider>
  );
};

export default UnauthenticatedWrapper;
